module.exports = __webpack_public_path__ + "static/media/automobile-car-cop-svgrepo-com.2817c5a8.svg";